import React from "react";
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import { GridLegacy, MenuItem } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import AsyncProductAutocompleteTC from "../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { useController, useFormContext } from "react-hook-form";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";

function Overige() {
  const { menukaartVestigingId: salesareaId } = useFormContext();

  const {
    field: { value: payDirectValue },
  } = useController({ name: "payDirect" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy container item lg={6} xs={12}>
          <Card>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <GridLegacy item xs={12}>
                <h3>{getTranslation("vestigingen.form.other.headers.other", "Other settings")}</h3>
              </GridLegacy>
              {payDirectValue == 0 ? (
                <FormSwitchTC
                  name={"queueorders"}
                  tDefault={"Order queue gebruiken"}
                  tKey={"vestigingen.form.overige.label.queueorders"}
                />
              ) : null}
              <FormSwitchTC
                name={"extra_settings__catOrderChecker"}
                tDefault={"Order checker on categorie level"}
                tKey={"vestigingen.form.overige.label.catOrderChecker"}
              />
              <FormSwitchTC
                name={"useNewQueues"}
                tDefault={"Queue system v2 (dev only)"}
                tKey={"vestigingen.form.overige.label.useNewQueues"}
              />
              <FormSwitchTC
                name={"use_kds_data"}
                tDefault={"Use KDS volatile data (dev only)"}
                tKey={"vestigingen.form.overige.label.use_kds_data"}
              />
              <FormSwitchTC
                name={"apiaccounts__wait_for_dispatch"}
                tDefault={"Wait on pos dispatch UX"}
                tKey={"apiaccounts.wait_for_dispatch"}
              />
              <FormSwitchTC
                name={"extensive_logging"}
                tDefault={"Extensive logging"}
                tKey={"vestigingen.form.overige.label.extensive_logging"}
              />
              <FormSwitchTC
                name={"extra_settings__smsPolling"}
                tDefault={"Use SMS order polling"}
                tKey={"vestigingen.form.overige.label.extra_settings__smsPolling"}
              />
              <FormSwitchTC
                name={"extra_settings__tableTickets"}
                tDefault={"Table tickets"}
                tKey={"vestigingen.form.overige.label.extra_settings__tableTickets"}
              />
              <FormSwitchTC
                name={"extra_settings__reloadFromQueue"}
                tDefault={"Reload/save to queue"}
                tKey={"vestigingen.form.overige.label.extra_settings__reloadFromQueue"}
              />
              <FormSwitchTC
                name={"useProductStock"}
                tDefault={"use product stock"}
                tKey={"vestigingen.form.overige.label.useProductStock"}
              />
              <FormSwitchTC
                name={"deliveryLocationOverwrite"}
                tDefault={"Force delivery"}
                tKey={"vestigingen.form.overige.label.deliveryLocationOverwrite"}
              />
              <FormSwitchTC
                name={"upsellUnderProduct"}
                tDefault={"Upsell under product"}
                tKey={"vestigingen.form.overige.label.upsellUnderProduct"}
              />
              <FormSwitchTC
                name={"apiLoadTables"}
                tDefault={"Tafels"}
                tKey={"vestigingen.form.overige.label.apiLoadTable"}
              />
              <FormSwitchTC
                name={"showOptionCustomText"}
                tDefault={"Show option text"}
                tKey={"vestigingen.form.overige.label.showOptionCustomText"}
              />
              <FormSwitchTC
                name={"assignSlot"}
                tDefault={"Assign slot"}
                tKey={"vestigingen.form.overige.label.assignSlot"}
              />
              <AsyncProductAutocompleteTC
                async_url={`core/producten/search?fields=id as value,naam as label,id,naam,snaam,blocked,is_actief,prijs&per_page=150&sort_field=naam&vestiging_id=${salesareaId}`}
                name={"autoOrderItem"}
                nullable={true}
                tDefault={"Auto order item #id"}
                tKey={"vestigingen.form.overige.label.autoOrderItem"}
              />
              <FormControlledInputTC
                name={"apiaccounts__max_retry"}
                rules={{
                  min: {
                    value: 1,
                    message: getTranslation("The value must not be negative!"),
                  },
                }}
                tDefault={"Max retry"}
                tKey={"printers.form.algemeen.label.max_retry"}
                type={"number"}
              />
              <FormTextTC
                name={"logoutPassword"}
                tDefault={"Logout password"}
                tKey={"vestigingen.form.overige.label.logoutPassword"}
              />
              <FormTextTC
                name={"targetPlatform"}
                tDefault={"App Service URL"}
                tKey={"vestigingen.form.algemeen.label.REP"}
              />
              {/*<FormSwitchTC*/}
              {/*  name={"multibtw"}*/}
              {/*  tKey={"vestigingen.form.algemeen.label.multibtw"}*/}
              {/*  tDefault={"Multi VAT"}*/}
              {/*/>*/}
              <FormSwitchTC name={"preLoad"} tDefault={"Preloading"} tKey={"vestigingen.form.algemeen.label.preLoad"} />
              <FormSwitchTC
                name={"cleanKiosk"}
                tDefault={"Clean Kiosk"}
                tKey={"vestigingen.form.algemeen.label.cleanKiosk"}
              />
              <FormSwitchTC
                name={"headerPRL"}
                tDefault={"Header PRL"}
                tKey={"vestigingen.form.algemeen.label.headerPRL"}
              />
              <FormSwitchTC name={"visuals"} tDefault={"Visuals"} tKey={"vestigingen.form.algemeen.label.visuals"} />
              <FormControlledInputTC
                name={"refreshTimeout"}
                rules={{
                  min: {
                    value: 0,
                    message: getTranslation("The value must not be negative!"),
                  },
                }}
                tDefault={"Refresh Timeout"}
                tKey={"vestigingen.form.algemeen.label.refreshTimeout"}
                type={"number"}
              />
              <FormControlledInputTC
                defaultValue={900}
                name={"custom_data.polling_interval_data_reload_v5"}
                rules={{
                  min: {
                    value: 900,
                    message: getTranslation("The minimal value is 900 seconds."),
                  },
                }}
                tDefault={"Polling interval (Menu reload) Failsafe in seconds"}
                tKey={"vestigingen.form.algemeen.label.polling_interval_data_reload_v5"}
                type={"number"}
              />
            </CardBody>
          </Card>
        </GridLegacy>
        <GridLegacy item lg={6} xs={12}>
          <Card>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <FormSwitchTC
                name={"showFooterMenu"}
                tDefault={"Show footer Menu"}
                tKey={"vestigingen.form.algemeen.label.showFooterMenu"}
              />
              <FormSwitchTC
                name={"alwaysLoad"}
                tDefault={"Always load"}
                tKey={"vestigingen.form.algemeen.label.alwaysLoad"}
              />
              <FormSwitchTC
                name={"printValues"}
                tDefault={"Print values"}
                tKey={"vestigingen.form.algemeen.label.printValues"}
              />
              <FormTextTC name={""} tKey={"Toggle product list"} />
              <FormTextTC
                name={"extra_settings__headerHtml"}
                rows={5}
                tDefault={"Header HTML"}
                tKey={"vestigingen.form.berichten.label.headerHtml"}
              />
              <FormTextTC
                name={"extra_settings__bodyHtml"}
                rows={5}
                tDefault={"Body HTML"}
                tKey={"vestigingen.form.berichten.label.bodyHtml"}
              />
            </CardBody>
          </Card>
          <Card>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <GridLegacy item xs={12}>
                <h3>{getTranslation("vestigingen.form.overige.headers.adGraph", "Microsoft AD/Graph API")}</h3>
              </GridLegacy>
              <FormSwitchTC
                name={"extra_settings__azureOAuthEnabled"}
                tDefault={"Azure AD pre ordering"}
                tKey={"vestigingen.form.overige.label.extra_settings__azureOAuthEnabled"}
              />
              <FormSwitchTC
                name={"extra_settings__fakeAzureLogin"}
                tDefault={"Azure AD simulation mode"}
                tKey={"vestigingen.form.overige.label.extra_settings__fakeAzureLogin"}
              />
              <FormTextTC
                name={"apiaccounts__azureOAuthId"}
                tDefault={"Azure AD oAuth ID"}
                tKey={"vestigingen.form.overige.label.apiaccounts__azureOAuthId"}
              />
              <FormTextTC
                name={"apiaccounts__azureOAuthTentant"}
                tDefault={"Azure AD tenant ID"}
                tKey={"vestigingen.form.overige.label.apiaccounts__azureOAuthTentant"}
              />
              <FormTextTC
                name={"apiaccounts__azureOAuthPassword"}
                tDefault={"Azure AD oAuth pass"}
                tKey={"vestigingen.form.overige.label.apiaccounts__azureOAuthPassword"}
              />
              <FormTextTC
                name={"apiaccounts__azureOAuthRedirect"}
                tDefault={"Azure AD oAuth redirect"}
                tKey={"vestigingen.form.overige.label.apiaccounts__azureOAuthRedirect"}
              />
              <FormSwitchTC
                name={"use_estimated_waiting_time"}
                tDefault={"Use estimated waiting time"}
                tKey={"vestigingen.form.overige.label.use_estimated_waiting_time"}
              />
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

export default Overige;
